const o = {
  extends: "LottoAmerica",
  logo: !0
};
export {
  o as default
};
